import createRoute      from '@widesk-ui/tools/createRoute';
import ProductSaleModel from '@models/shop/ProductSaleModel';

export default createRoute.dashboard('/product_sales', 'shop', 'ProductSaleDashboard', ProductSaleModel.localize());
